module.exports = __webpack_public_path__ + "img/14.7eb09bef.jpg";